<lib-badge [type]="mood()" [text]="status() ?? 'Not arranged'" />

@if (canEdit()) {
  <button
    type="button"
    class="btn btn--small"
    [routerLink]="[]"
    [queryParams]="{ create: true }"
    [queryParamsHandling]="'replace'"
  >
    ✏️ Edit
  </button>
}
@if (nextStatus()) {
  <button
    type="button"
    class="btn btn--small"
    [routerLink]="[]"
    [queryParams]="{ changeState: nextStatus() }"
    [queryParamsHandling]="'merge'"
  >
    &rarr;
    {{ nextStatus() === 'Complete' ? 'Complete' : 'Start' }}
  </button>
}
